
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18.01 18.01"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.004.023a4.505 4.505 0 00-4.49 4.49 4.49 4.49 0 001.949 3.692A4.656 4.656 0 004.773 9.4c-.907 1.033-1.34 2.458-1.34 4.05v4.192l.594.243c.149.061.322.1.514.1h8.926c.192 0 .365-.039.513-.1l.594-.243V13.45c0-1.592-.432-3.017-1.34-4.05a4.656 4.656 0 00-1.69-1.195 4.492 4.492 0 001.95-3.691 4.505 4.505 0 00-4.49-4.49zm0 1.925a2.552 2.552 0 012.566 2.566A2.552 2.552 0 019.004 7.08a2.552 2.552 0 01-2.566-2.566 2.552 2.552 0 012.566-2.566zm0 7.698c1.486 0 2.271.442 2.784 1.025.525.597.862 1.536.862 2.779v2.61H5.358v-2.61c0-1.243.337-2.182.862-2.78.512-.582 1.298-1.024 2.784-1.024z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    